var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 12.3334V8.33341H3.66675V7.66675H7.66675V3.66675H8.33341V7.66675H12.3334V8.33341H8.33341V12.3334H7.66675Z",
    fill: "#232323"
  })));
};

export default __webpack_public_path__ + "static/media/add.e4549f9f.svg";
export { SvgComponent as ReactComponent };